import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [amount, setAmount] = useState(0);
  const [taskId, setTaskId] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const maxAttempts = 10;
    let stopped = false;
    const poll = async () => {
      if (stopped) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setAmount(data.amount);
        if (data.payment_status === "paid") {
          setStatus("paid");
          // Fetch tx for task_id
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts >= maxAttempts) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stopped = true; };
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto py-16 text-center">
      {status === "checking" && (
        <>
          <Loader2 size={56} className="mx-auto text-navy animate-spin" />
          <h1 className="mt-6 text-3xl font-heading font-black text-navy">Vérification du paiement…</h1>
          <p className="text-[#475569] mt-2">Quelques secondes.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="h-20 w-20 mx-auto rounded-full bg-lime flex items-center justify-center" data-testid="payment-success">
            <CheckCircle2 size={40} className="text-navy" />
          </div>
          <h1 className="mt-6 text-4xl font-heading font-black text-navy">Paiement confirmé</h1>
          <p className="text-[#475569] mt-2">Ton helper a été notifié et peut commencer la tâche.</p>
          {amount > 0 && <div className="mt-4 font-mono text-navy font-bold">Montant: {amount.toFixed(2)} $</div>}
          <button onClick={() => nav("/dashboard/client")} className="btn-primary mt-8" data-testid="go-dashboard">Retour au tableau</button>
        </>
      )}
      {(status === "expired" || status === "timeout") && (
        <>
          <XCircle size={56} className="mx-auto text-red-500" />
          <h1 className="mt-6 text-3xl font-heading font-black text-navy">Paiement non complété</h1>
          <p className="text-[#475569] mt-2">Tu peux réessayer depuis la tâche.</p>
          <button onClick={() => nav("/dashboard/client")} className="btn-outline mt-8">Retour</button>
        </>
      )}
    </div>
  );
}
